import React from "react";
import "../Loader/loader.css";

export const Loader = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};
